<template>
  <div id="customerReport">
    <div class="container">

      <Panel :title="$t('customer_report.terms.title')" collapsible>
        <TipBox info no-border>{{ $t('customer_report.terms.description') }}</TipBox>
        <TipBox danger no-border icon-top>
          <span v-html="$t('customer_report.terms.legal')"></span>
          <ol>
            <li v-for="link of legalLinks">
              <a class="inline" :href="$to(link.url)">{{ $to(link.name) }}</a>
            </li>
          </ol>
          <br>
          <hr>
          <br>
          <div class="group" :class="{ locked: !!acceptedTerm }">
            <input id="chkAcceptTerms" type="checkbox" v-model="userAcceptsTerms" :disabled="!!acceptedTerm"
              :readonly="!!acceptedTerm">
            <label id="label__chkAcceptTerms"
              for="chkAcceptTerms"><b>{{ $t('customer_report.terms.checkbox') }}</b></label>
          </div>
          <div class="terms-button" v-if="userAcceptsTerms && !acceptedTerm">
            <button class="btn-primary btn" @click="submitConsent">{{ $t('send') }}</button>
          </div>
          <div class="accepted-terms" v-if="acceptedTerm">
            {{ $t('customer_report.terms_accepted_by') }} <b>{{ acceptedTerm.user.username }}</b> {{ $t('on') }}
            <b>{{ acceptedTerm.agreedOn }}</b>
          </div>
        </TipBox>
      </Panel>

      <Panel :title="$t('customer_report.configuration')" v-if="acceptedTerm" collapsible>
        <div class="columns">

          <div class="column">
            <div class="group" v-if="branches.length > 1">
              <label>{{ $t('branches.title') }}</label>
              <select v-model="filters.branch">
                <option :value="branch.id" v-for="branch of branches">{{ branch.name }}</option>
              </select>
            </div>
            <div class="group" v-if="filters.branch">
              <label>{{ $t('companies.title') }}</label>
              <select v-model="filters.company">
                <option :value="null">{{ $t('all_f') }}</option>
                <option :value="company.id" v-for="company of companies">{{ company.name }}</option>
              </select>
            </div>
            <div class="group">
              <label>{{ $t('report_type') }}</label>
              <select v-model="report.selected">
                <option :value="r" v-for="r of report.all">{{ $t(r.tr) }}</option>
              </select>
            </div>
            <template v-if="report.selected && report.selected.name === 'customer'">
              <br>
              <div class="subtitle">{{ $t('customer_report.customer_type') }}</div>
              <div class="group">
                <input type="radio" id="chk_last_2_years" value="2" v-model="filters.customer">
                <label for="chk_last_2_years">{{ $t('customer_report.customer_last_2_years') }}</label>
                <input type="radio" id="chk_consented" value="consented" v-model="filters.customer">
                <label for="chk_consented">{{ $t('customer_report.customer_consented') }}</label>
                <input type="radio" id="chk_all_time" value="all" v-model="filters.customer">
                <label for="chk_all_time">{{ $t('customer_report.customer_all_time') }}</label>
              </div>
            </template>
          </div>

          <div class="column">
            <template v-if="customerReportSelected">
              <div class="subtitle">{{ $t('customer_report.data_to_export') }}</div>
              <div class="group">
                <template v-for="field of fields" v-if="field">
                  <input type="checkbox" :id="'chk_field' + field.key" v-model="field.included">
                  <label :for="'chk_field' + field.key">{{ $t('customer_report.field.' + field.key) }}</label>
                </template>
              </div>
            </template>
          </div>

        </div>

        <div class="buttons">
          <br>
          <button class="btn btn-primary" @click="fetch">{{ $t('generate') }}</button>
        </div>
      </Panel>

      <Panel ref="dataTab" :title="$t('customers.data')" v-if="tableData && acceptedTerm">
        <RawTable :columns="tableData.columns" :rows="tableData.rows" :keyValueHeader="tableData.query" />
      </Panel>

    </div>
  </div>
</template>
<script>
  import RawTable from '@/components/RawTable.vue';
  import { Core } from "@/core/Core";

  export default {
    name: "CustomerReport",

    components: { RawTable },

    data() {
      return {
        branches: [],
        companies: [],
        termsId: "export_customers",
        userAcceptsTerms: false,
        acceptedTerm: null,
        filters: {
          branch: null,
          customer: "2",
          company: null,
        },
        fields: [
          { key: "first_name", included: true },
          { key: "last_name", included: true },
          { key: "email", included: true },
          { key: "phone", included: true },
          { key: "language", included: true },
          { key: "zip_code", included: true },
          { key: "city", included: true },
          { key: "address", included: true },
          { key: "last_company", included: true },
          { key: "last_date", included: true },
          { key: "nb_orders", included: true },
          { key: "sum_spent", included: true },
          { key: "avg_spent", included: true }
        ],
        legalLinks: [
          {
            url: { fr: "https://www.fightspam.gc.ca/eic/site/030.nsf/fra/accueil", en: "https://www.fightspam.gc.ca/eic/site/030.nsf/eng/home" },
            name: { fr: "Portail d'information sur la Loi Canadienne Anti-Pourriel (LCAP - Canada)", en: "Canada's Anti-Spam Legislation (CASL - Canada) information portal" }
          },
          {
            url: { fr: "https://crtc.gc.ca/fra/com500/faq500.htm", en: "https://crtc.gc.ca/eng/com500/faq500.htm" },
            name: { fr: "Questions fréquentes (LCAP - Canada)", en: "Frequently Asked Questions (CASL - Canada)" }
          },
          {
            url: { fr: "https://www.ftc.gov/tips-advice/business-center/guidance/can-spam-act-compliance-guide-business", en: "https://www.ftc.gov/tips-advice/business-center/guidance/can-spam-act-compliance-guide-business" },
            name: { fr: "CAN-SPAM Act (USA)", en: "CAN-SPAM Act (USA)" }
          },
          {
            url: { fr: "https://ico.org.uk/for-organisations/guide-to-pecr/", en: "https://ico.org.uk/for-organisations/guide-to-pecr/" },
            name: { fr: "Privacy and Electronic Communications Regulations (PECR - UK)", en: "Privacy and Electronic Communications Regulations (PECR - UK)" }
          },
        ],
        report: {
          selected: null,
          all: [
            { tr: 'statistics.type.customer_data', name: 'customer', url: '/api/customer_data' },
            { tr: 'statistics.type.zip_code_data', name: 'zip_code', url: '/api/zip_code_data' }
          ]
        },
        tableData: null
      }
    },

    computed: {
      branch() {
        return this.$route.query.branch;
      },
      contextBranch() {
        return this.$store.state.contextBranch;
      },
      isLoyaltyActivated() {
        return this.contextBranch && this.contextBranch.loyaltyConfig && this.contextBranch.loyaltyConfig.activated;
      },
      customerReportSelected() {
        return this.report.selected && this.report.selected.name === 'customer';
      }
    },

    watch: {
      'filters.branch': {
        immediate: true,
        deep: true,
        async handler(branch) {
          this.companies = [];
          this.filters.company = null;
          if (!branch) {
            return;
          }
          showSpinner();
          let response = await Core.request('GET', '/api/entity/company/select', { branch: branch });
          hideSpinner();
          this.companies = response ? response : []
        }
      }
    },

    async mounted() {
      this.report.selected = this.report.all[0];
      showSpinner();
      await this.loadBranches();
      await this.getTerms();
      if (this.isLoyaltyActivated) {
        this.fields.push({ key: "loyalty_rank", included: true });
        this.fields.push({ key: "loyalty_points", included: true });
        this.fields.push({ key: "loyalty_balance", included: true });
      }
      hideSpinner();
    },

    methods: {
      async getTerms() {
        try {
          let response = await Core.request('GET', '/api/me/terms_agreements', { termsId: this.termsId });
          if (response && response.data) {
            this.acceptedTerm = response.data[0];
            this.userAcceptsTerms = !!this.acceptedTerm;
          } else {
            toast(this.$t("error.no_server"), "error");
            console.log(response);
          }
        } catch (e) {
          toast(this.$t("error.no_server"), "error");
          console.log(e)
        }
      },
      async submitConsent() {
        showSpinner();
        try {
          let response = await Core.request('POST', '/api/terms/' + this.termsId + '/accept');
          if (response) {
            this.acceptedTerm = response;
          } else {
            toast(this.$t("error.no_server"), "error");
            console.log(response);
          }
        } catch (e) {
          toast(this.$t("error.no_server"), "error");
          console.log(e)
        }
        hideSpinner();
      },
      async loadBranches() {
        let response = await Core.request('GET', '/api/entity/branch/select', { id: this.branch || undefined });
        this.branches = response ? response : [];
        this.filters.branch = this.branches[0] ? this.branches[0].id : null;
      },
      async fetch() {
        if (!this.report.selected) {
          return;
        }
        let filters = {
          branch: this.filters.branch || undefined,
          company: this.filters.company || undefined,
          columns: this.fields.filter(f => f.included).map(f => f.key)
        };
        switch (this.filters.customer) {
          case "2":
            filters.last_x_year = 2;
            break;
          case "consented":
            filters.consented = true;
            break;
          case "all":
          default:
            break;
        }
        let url = this.report.selected.url;
        let responses = [];
        let response = null;

        this.$store.commit("showSpinner", true);
        do {
          filters.page = (filters.page || 0) + 1;
          response = await Core.request("GET", url, filters);
          responses.push(response);
        } while (response.hasMore);
        this.$store.commit("showSpinner", false);

        this.tableData = {
          columns: responses[0].columns,
          rows: [].concat(...responses.map(r => r.rows)),
        };
        setTimeout(() => {
          this.$refs.tabs.setActive(this.$refs.dataTab);
        }, 0);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .buttons {
    button {
      margin-right: 10px;
    }
  }

  #label__chkAcceptTerms {
    color: inherit;
    font-size: inherit;

    &:before {
      border-color: #989898;
    }
  }

  .terms-button {
    display: flex;
    padding-top: 15px;
    width: 100%;
    align-items: center;
    justify-content: center;
  }
</style>